import { ButtonGroup, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import DataTableTitle from "../../DataTableComponents/DataTableTitle";
import { getDarkDropdown } from "../../../Utils/otherFunctions";
import { Link } from "react-router-dom";

const DaftarColumns = (themeContext, handleDownloadDokumen) => {
  
  return ([
  {
    name: <DataTableTitle text={"Judul"} />,
    selector: (row) => row.judul,
    sortable: true,
    wrap: true,
  },
  {
    name: <DataTableTitle text={"Deskripsi"} />,
    selector: (row) => row.deskripsi,
    sortable: true,
    wrap: true,
  },
  {
    name: <DataTableTitle text={"Dokumen"} />,
    cell: (row) => (
      <ButtonGroup>
        <UncontrolledDropdown>
          <DropdownToggle caret></DropdownToggle>
          <DropdownMenu>
            {row.dokumen.startsWith("/media/") && (
              <>
                <DropdownItem
                  className={getDarkDropdown(themeContext)}
                  onClick={(e) =>
                    handleDownloadDokumen(e, row.dokumen, row.judul)
                  }
                >
                  Download
                </DropdownItem>
              </>
            )}
            {row.dokumen.startsWith("/sikeuangan/") && (
              <>
                <DropdownItem className={getDarkDropdown(themeContext)}>
                  <Link to={row.dokumen} download={row.judul} target="_blank">
                    Download
                  </Link>
                </DropdownItem>
              </>
            )}
          </DropdownMenu>
        </UncontrolledDropdown>
      </ButtonGroup>
    ),
    width: "20%",
  },
])};

export default DaftarColumns;